import { Table } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { payoutPriceRenderer } from '../../utils/buybackPayoutHelpersNew'
import { Money } from '../Money/Money'

export interface BuybackFormPayoutBalanceTableSummaryProps {
  offerPrice: number
  totalOutcome: number
  requested: number
}

export const BuybackFormPayoutBalanceTableSummary: FunctionComponent<BuybackFormPayoutBalanceTableSummaryProps> =
  ({ offerPrice, totalOutcome, requested }) => {
    const balance = useMemo(() => {
      const total = offerPrice - totalOutcome
      const className =
        total < 0
          ? 'text-red-500'
          : total < requested
          ? 'text-orange-400'
          : 'text-lime-600'

      const description =
        total < 0 ? (
          <span className={className}>
            Výkupní cena nepokryje závazky klienta a celkové náklady.
          </span>
        ) : total < requested ? (
          <span className={className}>
            Klient obdrží o{' '}
            <Money
              amount={-(offerPrice - totalOutcome - requested)}
              symbol="Kč"
              decimalNumbers={0}
            />{' '}
            méně, než požadoval.
          </span>
        ) : (
          <span className={className}>
            Klient obdrží o{' '}
            <Money amount={total - requested} symbol="Kč" decimalNumbers={0} />{' '}
            více, než požadoval.
          </span>
        )

      return { total, className, description }
    }, [offerPrice, totalOutcome, requested])

    return (
      <Table.Summary>
        <Table.Summary.Row className="bg-[#fafafa]">
          <Table.Summary.Cell index={0} colSpan={2} className="font-semibold">
            K vyplacení na účet
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2}>
            {balance.description}
          </Table.Summary.Cell>
          <Table.Summary.Cell
            index={3}
            className={'text-right !font-semibold ' + balance.className}
          >
            {payoutPriceRenderer(balance.total)}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    )
  }
